// Frontend configuration. All values come from Vite's import.meta.env, which
// reads .env / .env.local at build time. Anything sensitive lives in the
// backend (Pages Functions) instead.

const env = import.meta.env;

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required env var ${name}. Copy .env.example to .env.`);
  }
  return value;
}

export const config = {
  supabaseUrl: required('VITE_SUPABASE_URL', env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', env.VITE_SUPABASE_ANON_KEY),
  apiBaseUrl: env.VITE_API_BASE_URL ?? '/api',
};
